import globalHelpers from './../helpers/global'

export default {
  install (vueApp, options) {
    vueApp.config.globalProperties.$utils = globalHelpers
  }
}
